import { useAuth } from 'providers/AuthProvider.jsx'

const useAuthToken = () => {
  return useAuth()
}

export default useAuthToken
